$.fn.compare = function() {
  const main = $(this);
  const id = main.attr('data-id');

  main.on('click', (e) => {
    e.preventDefault();
    storage.toggle('compare', id);
  });

  window.addEventListener('storage', () => {
    toggleClasses();
  });

  function toggleClasses() {
    const data = storage.get('compare').split(',');
    if (data.indexOf(id) !== -1) {
      main.removeClass('btn--secondary');
      main.add('btn--primary');
    } else {
      main.addClass('btn--secondary');
      main.removeClass('btn--primary');
    }
  }

  toggleClasses();
}